
const VisaForm = ({ submitHandler, changeHandler }) => {

    return (
        <form className="qvc-booking-form onboard-form" onSubmit={submitHandler}>

            <div className="onboard-form-field">
                <label>
                    Visa NO.:
                </label>

                <input type="text" name="visaNo" onChange={changeHandler} required />
            </div>

            <div className="onboard-form-field">
                <label>
                    Visa Issued Date:
                </label>

                <input type="date" name="visaIssuedDate" onChange={changeHandler} required />
            </div>

            <div className="onboard-form-field">
                <label>
                    Visa Expiry Date:
                </label>
                <input type="date" name="visaExpiryDate" onChange={changeHandler} required />
            </div>

            <div className="onboard-form-field">
                <label>
                    Visa – Attachment
                </label>

                <input type='file' name="visaAttachment" onChange={changeHandler} accept="image/png, image/jpeg, application/pdf" required />
            </div>

            <div className="submit-btn">
                <button className="onboard-general-btn" type="submit">Update Details</button>
            </div>
        </form>
    )
}

export default VisaForm;